var React = require('react');
var PropTypes = React.PropTypes;
import ReactDOM from 'react-dom';

var Solution = React.createClass({
  componentWillReceiveProps: function(nextProps) {
    this.setState({
      solution: nextProps.solution
    })
  },
  componentWillMount: function() {

  },
  getInitialState: function() {
    return {
      solution: this.props.solution
    };
  },
  render: function() {
    var _this = this;
    return (
      <div className="solution-content-wrapper">
        <h3>Solution</h3>
        {
          _this.state.solution.map(function(solution, index) {
            return (
              <div className="solution" key={index}>
                {
                  solution.type && solution.type.toLowerCase() === 'text' &&
                  <p dangerouslySetInnerHTML={{__html: solution.value}}></p>
                }
                {
                  solution.type && solution.type.toLowerCase() === 'image' &&
                  <img src={solution.value} alt={"Solution " + (index+1)} style={{width: "100%"}}/>
                }
              </div>
            )
          })
        }
      </div>
    );
  },
  componentDidMount: function() {

  },
  componentDidUpdate: function(prevProps) {
    var _this = this;
    window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub, ReactDOM.findDOMNode(_this)]);
  },
  

});

module.exports = Solution;



/** WEBPACK FOOTER **
 ** ./src/components/QuestionContent/Solution.js
 **/